<!-- 银行维护 -->
<template>
	<div class='page_content'>
		<el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false"
			append-to-bodycustom-class="drawer_box" direction="ltr" size="50%">
			<accountBooksManagerAction v-if="showStatus" ref="accountBooksManagerAction" @drawerCancel="drawerCancel"
				@toDetail="toDetail" :actionData="actionData"></accountBooksManagerAction>
		</el-drawer>
		<subComponents ref="showSelectData"></subComponents>
		<div class="page_content_top">
			<v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" :showRefresh="true" :buttonFlag="false"></v-button>

		</div>
		<div class="page_content_center">
			<el-table stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border
				style="width: 100%" highlight-current-row size="mini">
				<el-table-column label="选择操作" width="80">
					<template slot-scope="scope">
						<el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
							<i class="el-icon-thumb"></i>
						</el-radio>
					</template>
				</el-table-column>
				<el-table-column align="center"  prop="abookCode" label="账簿编号" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center"  prop="abookName" label="账簿名称" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center"  prop="abookAccount" label="账簿金额" show-overflow-tooltip>
				</el-table-column>
				
				<el-table-column align="center"  prop="isHonour" label="是否承兑" show-overflow-tooltip>
					<template slot-scope="scope">
						<el-tag size="mini" v-if="scope.row.isHonour == 1">是</el-tag>
						<el-tag size="mini" v-if="scope.row.isHonour == 0">否</el-tag>
					</template>
				</el-table-column>
				<el-table-column align="center"  prop="abookType" label="账簿类型" show-overflow-tooltip>
					<template slot-scope="scope">
						<el-tag size="mini" v-if="scope.row.abookType == 0">对公</el-tag>
						<el-tag size="mini" v-if="scope.row.abookType == 1">对私</el-tag>
					</template>
				</el-table-column>
				<el-table-column align="center"  prop="isDock" label="是否管理余额" show-overflow-tooltip>
					<template slot-scope="scope">
						<el-tag size="mini" v-if="scope.row.isDock == 1">是</el-tag>
						<el-tag size="mini" v-if="scope.row.isDock == 0">否</el-tag>
					</template>
				</el-table-column>
				<el-table-column align="center"  prop="purpose" label="账簿用途" show-overflow-tooltip>
					<template slot-scope="scope">
						<el-tag size="mini" v-if="scope.row.purpose == 1">结算</el-tag>
						<el-tag size="mini" v-if="scope.row.purpose == 2">零售</el-tag>
					</template>
				</el-table-column>
				<el-table-column align="center"  prop="payType" label="零售付款方式" show-overflow-tooltip>
					<template slot-scope="scope">
						<el-tag size="mini" v-if="scope.row.payType == 0">其他</el-tag>
						<el-tag size="mini" v-if="scope.row.payType == 1">现金</el-tag>
						<el-tag size="mini" v-if="scope.row.payType == 2">会员</el-tag>
						<el-tag size="mini" v-if="scope.row.payType == 3">微信</el-tag>
						<el-tag size="mini" v-if="scope.row.payType == 4">支付宝</el-tag>
						<el-tag size="mini" v-if="scope.row.payType == 5">医保</el-tag>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<div class="page_content_bottom">
			<v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total"
				@setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>

		</div>
		<el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
			<SearchScheme ref="searchScheme" :id="seId" :smId="smId" :parentSearchData="parentSearchData"
				@TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
		</el-dialog>
		<!-- 自定义设计 -->
		<customDesign ref="customDesign"></customDesign>
	</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Vue from "vue";
import SearchScheme from "@/byComponents/SearchScheme.vue";
import ExtractionScheme from "@/byComponents/ExtractionScheme.vue";
import accountBooksManagerAction from '@/components/accountBooksManagerAction.vue';
export default {
	//import引入的组件需要注入到对象中才能使用
	components: {
		SearchScheme,
		ExtractionScheme,
		accountBooksManagerAction,
	},
	data() {
		//这里存放数据
		return {
			tableHeight: 0,
			getRequestData: {
				smName: "",
				page: 1,
				rows: 30,
				smId: "",
			},
			returnData: {
				pages: 0, // 总页数
				total: 0, // 总条数
				pageNum: 0, // 当前页数
				list: [],
			},
			buttonList: [],
			pageShowData: [],
			formDataList: [],
			selectedDataIndex: 0,
			exId: "",
			seId: "",
			ceshi: "",
			dialogTitle: "",
			seWidth: "",
			height: "",
			exTitle: "",
			seTitle: "",
			seWidth: "",
			exWidth: "",
			DialogVisible: false,
			DialogExtract: false,
			seType: "",
			smId: "",
			isShowTooltip: false,
			showStatus: false,
			actionData: {},
			parentSearchData: {},
			sField: "",
		};
	},
	//监听属性 类似于data概念
	computed: {},
	//监控data中的数据变化
	watch: {
		"getRequestData.smName": {
			handler: function (newValue, oldValue) {
				if (newValue == "") {
					this.getRequestData.smId = "";
				}
			},
			deep: true,
		},
	},
	//方法集合
	methods: {
		changeTime(val) {
			if (val) {
				var time = val + 24 * 60 * 60 * 1000 - 1;
				this.getRequestData.end = time;
			}
		},
		// 子组件触发
		drawerCancel(commitData) {
			this.showStatus = false
			commitData && this.getDataList()
		},
		// 点击穿透字段 传参单号
		toDetail(orderId) {
			if (orderId) {
				// 设置为true 打开穿透组件首页
				var isPenetrate = true;
				// 设置缓存 存入点击单号
				this.resetSetItem("penetrateOrderId", orderId);
				// 与父级跨域通信 传递isPenetrate参数
				window.parent.postMessage({
					//向窗口发送MessageEvent消息
					cmd: "returnFormJson",
					params: {
						isPenetrate
					}, //参数
				},
					"*"
				);
			}
		},
		//检索带回数据
		changeInputModel(val) {
			if (val != "" || val != undefined) {
				this.DialogVisible = false;
				this.paramValue(val);
			}
		},
		// 赋值字段
		paramValue(val) {
			let arr = this.sField.split(",");
			arr.forEach((item) => {
				this.getRequestData[item] = val[item];
			});
		},
		getSeWidth(e) {
			console.log(e);
			this.seWidth = e + "%";
		},
		getWidth(e) {
			console.log(e);
			this.exWidth = e + "%";
		},
		getSearchName(e) {
			console.log(e);
			this.seTitle = e;
		},
		getExtractName(e) {
			console.log(e);
			this.exTitle = e;
		},
		// 检索Id, 索引(表格中), 标识
		openSearch(sId, index, type, sField) {
			this.DialogVisible = true;
			this.seId = sId;
			this.sField = sField;
			this.parentSearchData[type] = this.getRequestData[type];
		},
		isShowData(name, value) {
			switch (name) {
				case "supplier":
					var dataInfo = sessionStorage.getItem("selectSupplierData");
					if (dataInfo) {
						dataInfo = JSON.parse(dataInfo);
						this.getRequestData.psomBuycus = dataInfo.smId;
						this.getRequestData.smName = dataInfo.smName;
					}
					break;
			}
		},

		// 获取数据列表
		async getPageInfo() {
			var pathId = parent.getMenuInfo(this.$route.path);
			let responseData = await this.$http.getJur({
				ids: [pathId.jurId]
			});
			if (responseData.status == 200) {
				this.pageShowData = responseData.result;
				this.formDataList = this.pageShowData.jurFormVoList;
				this.getDataList();
				this.getButtonList();
			} else {
				this.$message({
					message: responseData.message,
					type: "error",
				});
			}
		},

		// 动作集合
		actionSet(actionData) {
	
			
			switch (actionData.actionType) {
				case 0:
					this.showStatus = true;
					this.actionData = {
						cate: 0,
						formData: [],
						oldData: "",
						orderId: "",
						printSouce: "",
						printJurId: "",
					};
					break;
				case 1:
					var dataInfo = this.returnData.list[this.selectedDataIndex];
					if (!dataInfo) {
						this.$message({
							message: "请先选中要操作的数据",
							type: "error",
						});
						return false;
					}
					this.showStatus = true;
					this.actionData = {
						cate: 1,
						formData: [],
						oldData: dataInfo,
						orderId: dataInfo.psomId,
						printSouce: "",
						printJurId: "",
					};
					break;
				case 2:
					this.delDataAction();
					break;
				case 15:
					this.openFormDesign()
					break;
			}
		},
		openFormDesign() {
			let pathInfo = parent.getMenuInfo(this.$route.path)
			this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
		},
		// 数据搜索
		searchData() {
			this.getRequestData.page = 1;
			this.getDataList();
		},
		// 数据翻页
		setDataPageNumber(val) {
			this.getRequestData.page = val;
			this.getDataList();
		},

		// 切换显示条数
		setDataPageSize(val) {
			this.getRequestData.page = 1;
			this.getRequestData.rows = val;
			this.getDataList();
		},

		// 获取数据列表
		async getDataList() {
			let responseData = await this.$http.queryAccountbook(
				this.getRequestData
			);
			if (responseData && responseData.status == 200) {
				let resData = JSON.parse(JSON.stringify(responseData));
				this.returnData.list = resData.result.list;
				this.returnData.pages = resData.result.pages;
				this.returnData.total = resData.result.total;
				this.returnData.pageNum = resData.result.pageNum;
				this.selectedDataIndex = 0;
			} else {
				this.$message({
					message: responseData.message,
					type: "error",
				});
			}
		},
		// 删除数据
		delDataAction() {
			var dataInfo = this.returnData.list[this.selectedDataIndex];
			if (!dataInfo) {
				this.$message({
					message: "请先选中要操作的数据",
					type: "error",
				});
				return false;
			}

			this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(async () => {
					var delData = {
						ids: [dataInfo.abookId],
					}
					let responseData = await this.$http.deleteAccountbook(delData);
					if (responseData.status == 200) {
						this.$message({
							type: "success",
							message: "删除成功!",
						});

						this.getDataList();
					} else {
						this.$message({
							message: responseData.message,
							type: "error",
						});
					}
				})
				.catch(() => { });
		},

		// 获取按钮权限
		async getButtonList() {
			this.buttonList = await this.$common.getActionButton()
			
		},
},
	//生命周期 - 创建完成（可以访问当前this实例）
	created() {
		this.getPageInfo();
	},
	//生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {
 },
	beforeCreate() { }, //生命周期 - 创建之前
	beforeMount() { }, //生命周期 - 挂载之前
	beforeUpdate() { }, //生命周期 - 更新之前
	updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
	beforeDestroy() { }, //生命周期 - 销毁之前
	destroyed() { }, //生命周期 - 销毁完成
	activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
	margin-right: 1rem;
}

.el-tabs--border-card_new {
	height: 85vh;
	overflow-y: scroll;
}

.el-drawer {
	outline: none;
}
</style>